/**
 * WebGL側の挙動をまとめたクラス
 */
import * as THREE from 'three';
import { createScene } from './core/threeCoreHandler';
import { createCamera } from './core/threeCoreHandler';
import { createRenderer } from './core/threeCoreHandler';
import { createRaycaster } from './utils/createRaycaster';
import { Sizes } from './utils/Sizes';
import { Text } from './world/Text';

export class WebGlApp {
  // Init
  private scene: THREE.Scene;
  private camera: THREE.PerspectiveCamera;
  private renderer: THREE.WebGLRenderer;
  private sizes: Sizes;
  private raycaster: THREE.Raycaster;

  // Custom
  private text: Text;

  constructor(canvas: HTMLCanvasElement) {
    this.sizes = new Sizes();
    this.raycaster = createRaycaster();

    // Three.js setup
    this.scene = createScene();
    this.camera = createCamera(this.sizes.width / this.sizes.height);
    this.renderer = createRenderer(canvas);
    this.renderer.setSize(this.sizes.width, this.sizes.height);

    // 環境光
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    this.scene.add(ambientLight);

    // ポイントライト
    const pointLight = new THREE.PointLight(0xffffff, 1);
    pointLight.position.set(50, 50, 50);
    this.scene.add(pointLight);

    // Set up resize event listener
    this.setupEventListeners();

    // Custom
    this.text = new Text(this.renderer);
  }

  // ------------------------ Public ------------------------
  /**
   * AppHandlerによってRAFごとに呼び出される関数
   */
  public render(): void {
    const elapsedTime = performance.now();
    this.update(elapsedTime);
    this.renderer.render(this.scene, this.camera);
  }
  public update(elapsedTime: number): void {
    this.text.update(elapsedTime);
  }

  public async initialize(): Promise<void> {
    await this.text.initialize();
    const instance = this.text.getInstance();
    if (instance) this.scene.add(instance);
  }

  // ------------------------ Private ------------------------
  // ブラウザのウィンドウサイズが変更されたときに実行
  private setupEventListeners(): void {
    this.sizes.setResizeCallback(() => {
      this.camera.aspect = this.sizes.width / this.sizes.height;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(this.sizes.width, this.sizes.height);
      this.renderer.setPixelRatio(this.sizes.pixelRatio);
    });
  }
}